import { Shield, Zap, Eye } from 'lucide-react'

export const SELF_DEFENSE_BENEFITS = [
  {
    icon: Eye,
    title: 'Situational Awareness',
    description:
      'The best self-defense is avoiding danger. Learn how to be aware of your surroundings and recognize potential threats early.',
  },
  {
    icon: Shield,
    title: 'Practical Fundamentals',
    description:
      'Learn simple, effective techniques based on Taekwondo principles that can help you create distance and escape.',
  },
  {
    icon: Zap,
    title: 'Unshakeable Confidence',
    description:
      'Knowing you have the skills to protect yourself changes how you carry yourself in everyday life.',
  },
]

export const SELF_DEFENSE_WHAT_YOU_LEARN = [
  'Situational awareness and threat recognition',
  'Distance management and de-escalation',
  'Effective striking techniques (kicks, punches, elbows)',
  'Escapes from common grabs and holds',
  'How to generate power using your whole body',
  'Improved physical fitness and reaction time',
]

export const SELF_DEFENSE_RELATED_LINKS = [
  {
    title: 'Adult Taekwondo',
    href: '/karate-adult-classes',
    description: 'Full adult martial arts training at Storm.',
  },
  {
    title: 'Family Classes',
    href: '/FamilyKarateClasses.html',
    description: 'Train together as a family.',
  },
  {
    title: 'Programs Overview',
    href: '/Programs.html',
    description: 'See every class and program Storm offers.',
  },
  {
    title: 'Contact Storm',
    href: '/ContactUs.html',
    description: 'Ask questions about self-defense classes.',
  },
  {
    title: 'Start a Trial Class',
    href: '/SignMeUp',
    description: 'Pick a starting class and visit Storm.',
  },
]
